import React, {Component} from 'react';
import styles from './Loading.module.css';
import Icon from '../components/Icon/Icon';

class Loading extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        return (
            <div className={styles.Loading}>
                <Icon name="spinner" className="icon-spin" />
            </div>
        );
    }
}

export default Loading;
